import customFetch from '~/composables/custom-fetch'
import apiConfig from '~/shared/config/api'
import getDateInfo from '~/composables/date-formatter'
import getWorkMode from '~/composables/get-work-mode'
import type { ICity } from '~/shared/interfaces/main'
import type { IBrandFilter, ISearchProduct, ISearchProductResult } from '~/shared/interfaces/search/products'
import type { H3Event, EventHandlerRequest } from 'h3'

function getSupplierUpdateAtDate(dateString: string | null) {
  if (dateString) {
    const dateInfo = getDateInfo(dateString, {
      timeStyle: 'short',
      dateStyle: 'short',
    })
    return dateInfo.dateFormated;
  }
  return '';
}

function getDeliveryDate(dateString: string) {
  const dateInfo = getDateInfo(dateString);
  return `до ${dateInfo.dateDay} ${dateInfo.monthName}`
}

async function getProductTable({ article, brand, citySlug }: Record<'article' | 'brand' | 'citySlug', string>, event?: H3Event<EventHandlerRequest>) {
  const { search } = apiConfig;
  if (article && brand && citySlug) {
    const reqTimeStart = performance.now()
    const { data: foundProducts, status, errors, executionTime } = await customFetch<ISearchProductResult>(search.searchByArticleAndBrand({
      query: {
        citySlug,
      },
      article,
      brand,
    }), event);

    if (foundProducts?.original && foundProducts.analogs) {
      let originalProduct: ISearchProduct | null = null;
      let pricesList: number[] = [];
      const productAnalogsList: ISearchProduct[] = [];
      const citiesList: { [key: string]: ICity } = {};
      const brandsList: { [key: string]: IBrandFilter } = {};
      const originalTypePartner = foundProducts.original.warehouses.filter(i => i.type === 'partner');

      [foundProducts.original, ...foundProducts.analogs].forEach((product, index) => {
        if (product && product.warehouses.length) {
          const productWarehouses: ISearchProduct['warehouses'] = [];
          const isOriginalProduct = index == 0;
          pricesList = []

          product.searchLink = `/search/${product.article}`;
          product.warehouses.forEach(warehouse => {
            pricesList.push(warehouse.price);
            citiesList[warehouse.city.id] = warehouse.city;
            productWarehouses.push({
              ...warehouse,
              quantityWithReserve: (warehouse.reserve || 0) > 0 ? warehouse.quantity - (warehouse.reserve || 0) : warehouse.quantity,
              productLink: warehouse.type !== 'partner' || isOriginalProduct ? (originalTypePartner.length === product.warehouses.length && warehouse.type == 'partner' ? '' : `/search/product/${warehouse.productId}`) : ``,
              supplierDate: getSupplierUpdateAtDate(warehouse.pricelist?.updatedAt || null),
              workModeHtml: warehouse.workMode ? getWorkMode(warehouse.workMode, {
                isBold: true,
                lineBreak: true,
              }) : '',
              deliveryDateText: warehouse.dateDelivery ? getDeliveryDate(warehouse.dateDelivery) : 'в наличии',
              reserve: (warehouse.reserve || 0) > 0 ? warehouse.reserve : 0,
              purchasePrice: warehouse.pricelist ? Math.floor((warehouse.price * 100) / (warehouse.pricelist.markup + 100)) : 0,
            })
          });

          product.warehouses = productWarehouses;
          const brandMinPrice = Math.min(...pricesList);
          if (brandsList[product.brand.id] && brandsList[product.brand.id].price > brandMinPrice) brandsList[product.brand.id].price = brandMinPrice;
          if (!brandsList[product.brand.id]) {
            brandsList[product.brand.id] = {
              ...product.brand,
              price: brandMinPrice,
            };
          }
          if (isOriginalProduct) {
            originalProduct = product;
          } else {
            productAnalogsList.push(product);
          }
        }
      });
      const reqTimeEnd = performance.now() - reqTimeStart
      return {
        data: {
          cityFlag: foundProducts?.cityFlag,
          reqTimeApi: reqTimeEnd,
          executionTime: executionTime,
          citiesList: Object.values(citiesList),
          brandsList: Object.values(brandsList),
          originalProduct,
          productAnalogsList,
        },
        status,
        errors,
      }
    }
  }
  return null;
}
export default getProductTable;
